/* global AOS */

// **********************************************************
// Fade effects
// **********************************************************

// eslint-disable-next-line no-new
AOS.init({
  disable: 'mobile',
  once: true,
  anchorPlacement: 'top-bottom',
});
